"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
function reversePosition(pos) {
    if (pos === 'end')
        return 'start';
    if (pos === 'start')
        return 'end';
    return pos;
}
// eslint-disable-next-line complexity
function compileRatingStyle(branding) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const { rating = {} } = branding;
    const innerPosition = (_a = rating === null || rating === void 0 ? void 0 : rating.block) === null || _a === void 0 ? void 0 : _a.innerPosition;
    const borderWidth = rating === null || rating === void 0 ? void 0 : rating.borderWidth;
    return (0, utils_1.process)({
        'rating-options-count-2-max-width': (_b = rating === null || rating === void 0 ? void 0 : rating.block) === null || _b === void 0 ? void 0 : _b.count2maxWidth,
        'rating-options-count-3-max-width': (_c = rating === null || rating === void 0 ? void 0 : rating.block) === null || _c === void 0 ? void 0 : _c.count3maxWidth,
        'rating-options-max-width': (_d = rating === null || rating === void 0 ? void 0 : rating.block) === null || _d === void 0 ? void 0 : _d.maxWidth,
        'rating-options-position': (_e = rating === null || rating === void 0 ? void 0 : rating.block) === null || _e === void 0 ? void 0 : _e.position,
        'rating-border-active': (_f = rating === null || rating === void 0 ? void 0 : rating.colors) === null || _f === void 0 ? void 0 : _f.borderActive,
        'rating-border-inactive': (_g = rating === null || rating === void 0 ? void 0 : rating.colors) === null || _g === void 0 ? void 0 : _g.borderInactive,
        'rating-focus-visible-border-color': (_j = (_h = rating === null || rating === void 0 ? void 0 : rating.focusVisible) === null || _h === void 0 ? void 0 : _h.border) === null || _j === void 0 ? void 0 : _j.color,
        'rating-border-inactive-hover': (_k = rating === null || rating === void 0 ? void 0 : rating.colors) === null || _k === void 0 ? void 0 : _k.borderInactiveHover,
        'rating-fill-active': (_l = rating === null || rating === void 0 ? void 0 : rating.colors) === null || _l === void 0 ? void 0 : _l.fillActive,
        'rating-fill-inactive': (_m = rating === null || rating === void 0 ? void 0 : rating.colors) === null || _m === void 0 ? void 0 : _m.fillInactive,
        'rating-fill-inactive-hover': (_o = rating === null || rating === void 0 ? void 0 : rating.colors) === null || _o === void 0 ? void 0 : _o.fillInactiveHover,
        'rating-gap': rating === null || rating === void 0 ? void 0 : rating.gap,
        'rating-stroke-width': isNaN(Number(borderWidth)) ? undefined : borderWidth,
        'rating-justify-content': innerPosition !== null && innerPosition !== void 0 ? innerPosition : undefined
    });
}
exports.default = compileRatingStyle;
